import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';

import '@/app/globals.css';
import { router } from '@/router';

// Aba aberta durante um deploy pede chunk que não existe mais: recarrega uma vez (T07 §6.5, T08 L41).
window.addEventListener('vite:preloadError', () => {
    if (sessionStorage.getItem('recarregou-chunk')) return;
    sessionStorage.setItem('recarregou-chunk', '1');
    window.location.reload();
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <RouterProvider router={router} />
    </StrictMode>,
);
